import Select2 from 'select2'
import Is from './is.js'

export default class Form
{
	static init()
	{
		this.select_picker()
		this.file_image()
		this.file_input()
		this.text_editor()
		this.limit_number_input()
	}

	static select_picker()
	{
		Select2($)

		$('select:not(.__no-select)').each((index, element) =>
		{
			const option = {
				dropdownAutoWidth: true,
			}

			if($(element).data('select-search') !== 1) option.minimumResultsForSearch = -1

			$(element).select2(option)
			$(element).css('visibility', 'visible')
		})

		$(document).on('select2:open', () =>
		{
			document.querySelector('.select2-search__field').focus()
		})
	}

	static file_image()
	{
		const input_image = $('input.__image_select[type="file"]')

		input_image.each((index, input) =>
		{
			const preview = $(input).data('preview')
			if(!Is.filled(preview)) return

			const tag = document.querySelector(preview)
			if(!tag) return

			const original = tag.src

			input.addEventListener('change', function()
			{
				//@ts-ignore
				tag.src = this.files.length > 0 ? URL.createObjectURL(this.files[0]) : original
				tag.parentNode.href = tag.src
			})
		})
	}

	static file_input()
	{
		$('input[type="file"]:not([class="__image_select"])').jfilestyle({
			text : 'ファイル選択',
			badge: true,
			input: false,
		})
	}

	static text_editor()
	{
		if($('.__editor').length === 0) return

		$('.__editor').each((index, element) =>
		{
			// noinspection JSUnresolvedVariable
			ClassicEditor.create(element, {
				width      : 'auto',
				image      : {
					resizeUnit: 'px',
				},
				htmlSupport: {
					allow: [
						{
							name      : /.*/,
							attributes: true,
							classes   : true,
							styles    : true,
						},
					],
				},
				link       : {
					decorators: {
						isExternal: {
							mode      : 'manual',
							label     : '新規タブで開く',
							attributes: {
								target: '_blank',
							},
						},
					},
				},
			}).then(editor =>
			{
				$(element).data('editor', editor)
			})
		})
	}

	static limit_number_input()
	{
		$('input[type="number"]').each((index, element) =>
		{
			element.addEventListener('input', function()
			{
				if(this.maxLength > 0) this.value = this.value.slice(0, this.maxLength)
			})
		})
	}
}
